import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export const TOKEN_KEY = 'cp_admin_token';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private http = inject(HttpClient);
  private base = environment.apiUrl;

  private headers(): HttpHeaders {
    const token = sessionStorage.getItem(TOKEN_KEY) ?? '';
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    });
  }

  async get<T = any>(path: string, params: Record<string, string> = {}): Promise<T> {
    let hp = new HttpParams();
    for (const [k, v] of Object.entries(params)) hp = hp.set(k, v);
    return firstValueFrom(
      this.http.get<T>(`${this.base}${path}`, { headers: this.headers(), params: hp })
    );
  }

  async post<T = any>(path: string, body: any = {}): Promise<T> {
    return firstValueFrom(
      this.http.post<T>(`${this.base}${path}`, body, { headers: this.headers() })
    );
  }

  async patch<T = any>(path: string, body: any = {}): Promise<T> {
    return firstValueFrom(
      this.http.patch<T>(`${this.base}${path}`, body, { headers: this.headers() })
    );
  }

  async delete<T = any>(path: string, body: any = {}): Promise<T> {
    return firstValueFrom(
      this.http.request<T>('DELETE', `${this.base}${path}`, {
        headers: this.headers(),
        body,
      })
    );
  }

  setToken(token: string) { sessionStorage.setItem(TOKEN_KEY, token); }
  clearToken()            { sessionStorage.removeItem(TOKEN_KEY); }
}
